/* =========================================================================
   Avaliações — rede de segurança do widget do Judge.me.

   A seção usa a marcação oficial de instalação manual (ver comentário do
   .liquid). Nela o app renderiza dentro de #judgeme_product_reviews, e o HTML
   do metacampo fica DENTRO da div, escondido, em .jdgm-legacy-widget-content.

   O QUE ESTE ARQUIVO FAZ, e só isso:

   1. Se o app NÃO renderizar em 6s, revela o conteúdo legado. Sem isso a
      seção fica em branco quando o script deles falha — que é exatamente o
      que aconteceu enquanto eu não sabia da marcação correta.
   2. No conteúdo legado, preenche foto (`data-src` -> `src`) e data
      (`datetime` -> texto), porque quem faria isso é o JS do app.
   3. Marca se o CSS deles não carregou, para o nosso desenhar as estrelas
      sem sair dobrado.

   >>> SÓ MEXE NO QUE É NOSSO. <<<
   O elemento revelado é o `.jdgm-legacy-widget-content` que o NOSSO Liquid
   escreveu. Nada do que o app renderizou é tocado — foi mutar o DOM deles
   que quebrou o "Carregar mais" numa tentativa anterior.
   ========================================================================= */

(function () {
  var ESPERA = 6000;

  function preencher(escopo) {
    // Fotos: sem isso o navegador mostra o texto alternativo como link.
    escopo.querySelectorAll('.jdgm-rev__pic-img[data-src]').forEach(function (img) {
      if (!img.getAttribute('src')) {
        img.setAttribute('src', img.getAttribute('data-src'));
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
      }
    });

    // Datas: valor em `datetime`, texto visível vazio.
    escopo.querySelectorAll('time.jdgm-rev__timestamp').forEach(function (t) {
      if (t.textContent.trim()) return;
      var iso = t.getAttribute('datetime');
      if (!iso) return;
      var d = new Date(iso);
      if (isNaN(d.getTime())) return;
      try {
        t.textContent = d.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        });
      } catch (e) {
        t.textContent = iso.slice(0, 10).split('-').reverse().join('/');
      }
    });
  }

  /* O app renderizou? Ele injeta conteúdo próprio dentro da div oficial. Se
     lá só existe o nosso bloco legado, ele não veio. */
  function appRenderizou(oficial) {
    if (!oficial) return false;
    var filhos = oficial.children;
    for (var i = 0; i < filhos.length; i++) {
      if (!filhos[i].classList.contains('jdgm-legacy-widget-content')) return true;
    }
    return false;
  }

  function conferir() {
    var raiz = document.querySelector('[data-tp-rev-widget]');
    if (!raiz) return;

    var oficial = raiz.querySelector('#judgeme_product_reviews');
    var legado = raiz.querySelector('[data-tp-rev-legado]');

    if (appRenderizou(oficial)) {
      /* App no comando: ele tem paginação, ordenação e lightbox. O legado
         segue escondido, como a documentação deles prevê. */
      raiz.classList.add('tp-rev--app-ok');
      return;
    }

    // App não veio: revela o nosso fallback para a seção não ficar vazia.
    if (legado) {
      legado.style.display = 'block';
      preencher(legado);
    } else {
      preencher(raiz); // modo "metacampo", em que o HTML já está solto
    }

    /* Estrela: os <span> são vazios e o glifo vem do CSS deles. Se não
       carregou, largura fica ~0 e o nosso CSS desenha. Medir é mais
       confiável do que checar window.jdgm — o que importa é estar desenhada. */
    var estrela = raiz.querySelector('.jdgm-star');
    if (estrela && estrela.offsetWidth < 4) raiz.classList.add('tp-rev--sem-css');
  }

  function iniciar() {
    // Modo "metacampo" não espera app nenhum: preenche já.
    var raiz = document.querySelector('[data-tp-rev-widget]');
    if (raiz && !raiz.querySelector('#judgeme_product_reviews')) {
      preencher(raiz);
      var e = raiz.querySelector('.jdgm-star');
      if (e && e.offsetWidth < 4) raiz.classList.add('tp-rev--sem-css');
      return;
    }
    setTimeout(conferir, ESPERA);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  document.addEventListener('tp:versao:trocada', function () {
    setTimeout(iniciar, 60);
  });
})();
